import { Button, useClipboard } from '@chakra-ui/react';
import { LuCopy } from 'react-icons/lu';

const CopyButton = ({ text, label }: { text: string; label?: string }) => {
  const { copy, copied } = useClipboard({ value: text });

  return (
    <Button size="xs" variant="ghost" color="purple.fg" onClick={copy} py={0.5} px={2}>
      <LuCopy size={14} />
      {copied ? 'Copied' : label || 'Copy Text'}
    </Button>
  );
};

export default CopyButton;
